const $ = require('jquery');
const Backbone = require('backbone');
const { KEYCODE_VALIDATION } = require('lib/enums');
const dustjs = require('dustjs');
const _keyCodeErrorDust = require('store/global/pages/products/_key_code_error.dust');
const gtmHelper = require('lib/helpers/gtm_helper');

const keyCodeView = Backbone.View.extend({
	events: {
		keyup: '_validateKeyCode',
		change: '_validateKeyCode'
	},
	_validateKeyCode(e) {
		const keyCode = $(e.currentTarget).val();
		const isString = isNaN(keyCode);
		const isInternal = window.dataLayer.isLocalUser;
		const isInternalString = isInternal && isString;
		const isKeyUpEvent = e.type === 'keyup';
		const keyCodeInvalidLength = keyCode.length < 5 || keyCode.length > 6;
		const shouldIgnoreKeyUp = isKeyUpEvent && keyCodeInvalidLength && !isString && !isInternal;
		const shouldIgnoreBlur = !isKeyUpEvent && !keyCodeInvalidLength && !isString;

		if (shouldIgnoreBlur) {
			return;
		}

		this._clearErrorMessage();

		if (!keyCode || isInternalString || shouldIgnoreKeyUp) {
			return;
		}

		this.isKeyUpEvent = isKeyUpEvent;

		const uniqueId = window.dataLayer.selectedFinish.uniqueId;

		if (isString || keyCodeInvalidLength) {
			return this._updateErrorMessage('Key codes are 5 or 6 numbers long.');
		}

		if (!this.validationInProgress) {
			this.validationInProgress = true;
			$.ajax({
				url: `/app/api/keyCode/${keyCode}/validate`,
				method: 'POST',
				data: { productUniqueIds: [uniqueId] }
			})
				.then(this._handleKeyCodeValidationResponse.bind(this))
				.always(() => {
					this.validationInProgress = false;
				});
		}
	},
	_handleKeyCodeValidationResponse(res) {
		const message = this._getErrorMessage(res.code);
		this._updateErrorMessage(message);
	},
	_getErrorMessage(errorCode) {
		let errorMessage = '';

		if (errorCode === KEYCODE_VALIDATION.INVALID_KEYCODE) {
			errorMessage = 'Key code is invalid.';
		}

		return errorMessage;
	},
	_clearErrorMessage() {
		const $keyCodeInput = $('.js-key-code input');
		$keyCodeInput.removeClass('b--theme-error ba');
		$('.js-key-code-message').remove();
		window.dataLayer.hasInvalidKeyCode = false;
	},
	_updateErrorMessage(message) {
		const $keyCodeInput = $('.js-key-code input');
		const keyCode = $keyCodeInput.val();
		let isValid = true;

		if (message) {
			isValid = false;
			$keyCodeInput.addClass('b--theme-error ba');
			window.dataLayer.hasInvalidKeyCode = true;
			dustjs.render(_keyCodeErrorDust, { message }, function(err, html) {
				if (err) {
					return window.clientErrorHandler(err);
				}
				$('.js-key-code').append(html);
			});
		}

		if (!this.isKeyUpEvent) {
			this._trackValidationError(keyCode, isValid);
		}
	},
	_trackValidationError(keyCode, isValid) {
		const data = [
			`kc:${keyCode}`,
			`m:${window.dataLayer.manufacturer}`,
			`uid:${window.dataLayer.selectedFinishId}`,
			`status:${isValid ? 'valid' : 'invalid'}`
		];
		const trackingData = {
			evars: {
				eVar85: `_${data.join('_')}`
			},
			linkName: 'Key Code Validation'
		};

		gtmHelper.fireEvent({
			event: 'key-code-validation',
			linkName: trackingData.linkName,
			validationData: trackingData.evars.eVar85
		});

		Backbone.trigger('track:link', trackingData);
	}
});

module.exports = keyCodeView;
